/** Libellé affiché pour une option de select widget (ex. `cta_position`). */
export const getWidgetSelectOptionLabel = (
  itemKey: string,
  optionValue: string,
  t: (key: string, options?: Record<string, unknown>) => string
): string => {
  if (itemKey === 'cta_position') {
    return t(`admin.contentblock.editor.cta_position.${optionValue}`);
  }

  return optionValue;
};
